import React, { useCallback, useRef, useState } from 'react';
import { useEffect } from 'react';
import { endpoints } from '../../utils/Constants';
import { Button } from 'reactstrap';
import { useHistory, } from 'react-router-dom';
import { useFetchEntitySingle } from '../../Services/fetchApi';
import Modal from './Modal';
import FormContainer from './FormContainer';
import { useAuth } from '../../Services/AuthContext';
import useFunction from '../../utils/Hooks/useFunction';
import { useAlert } from '../../Services/AlertContext';
import RouteModal from './RouteModal';
import EditorTitle from './EditorTitle';
import LoadingAnimation from '../Form/LoadingAnimation';
import ExtraDataModal from './ExtraDataModal';
import ConfirmationModal from './ConfirmationModal';
import entities from '../../utils/entities';
import useFetchSimple from '../../Services/useFetchSimple';
import useFetch from '../../Services/useFetch';
import { base64Encode } from '../../utils/Helpers';
import { RefreshProvider } from '../../Services/RefreshContext';

const getDetailId = (detail) => (detail?.id ? detail.id : "") + (detail?.status ? detail.status : "") + (detail?.changePending ? '1' : '0') + (detail?.shared ? '1' : '0') + (detail?.supplierUnavailable ? '1' : '0');
const Editor = ({ route, entity, itemId, item, newItem, edit, editorClosed, asNewItem, children, onSave, hideSave, data }) => {

    const f = () => false;
    const t = () => true;
    const p = (x) => {
        return x?.status === 'Pending';
    };
    const appRoutes = {

        resetPassword: { entity: entities.resetPassword },
        placeBid: { entity: entities.placeBid },
        itineraryPdf: { entity: entities.itineraryPdf, edit: f },
        bidHistoryPdf: { entity: entities.bidHistoryPdf, edit: f },
        moveClientToDepartment: { entity: entities.moveClientToDepartment },
        moveDepartmentToStaff: { entity: entities.moveDepartmentToStaff },
        changeMasterClient: { entity: entities.changeMasterClient },
        changeMasterDepartment: { entity: entities.changeMasterDepartment },
        notCheckedDocuments: { entity: entities.recentDocument },
        charterShare: {
            entity: entities.charterShare, edit: p
        },
        purchaseShare: { entity: entities.charterSharePurchase },
        changeCharterClient: { entity: entities.changeCharterClient },
        viewChangeCharter: { entity: entities.viewChangeCharter, edit: f },
        changeCharterSupplier: { entity: entities.changeCharterSupplier },
        changeCharterResponseClient: { entity: entities.changeCharterClient },
        changeCharterResponseSupplier: { entity: entities.changeCharterResponseSupplier, edit: t },
        manifest: { entity: entities.manifest },
        //emailSupplier: { entity: entities.supplierEmail },
        //emailClient: { entity: entities.clientEmail },
        payLoadReport: { entity: entities.payLoadReport },
        supplierUnavailable: { entity: entities.supplierUnavailable },
        supplierAvailable: { entity: entities.supplierAvailable },
        changeEmail: { entity: entities.changeEmail },
        suppliersEmail: { entity: entities.selectSuppliers },
        downloadExcel: { entity: entities.downloadExcel },
        cloneCharterRequest: { entity: entities.cloneCharterRequest }
    };

    const isNewItem = newItem || asNewItem;
    const [detail, setDetail] = useState(asNewItem);
    const [detailId, setDetailId] = useState(getDetailId(detail));
    const [fetchDetail, loadingRequest, errorRequest, refreshDetail, fetchDetailData] = useFetchEntitySingle(entity, !isNewItem && itemId ? itemId : null);
    const [loading, setLoading] = useState(false);
    const [editState, setEdit] = useState(edit);
    let history = useHistory();
    const [actions, setActions] = useState([])
    const [auth] = useAuth();
    const [handleSubmit, setHandleSubmit] = useFunction();
    const [isSubmitting, setSubmit] = useState(false);
    const [appRoute, setAppRoute] = useState();
    const [newNotSaved, setNewNotSaved] = useState(newItem);
    const [extraData, setExtraData] = useState();
    const [extraDataResult, setExtraDataResult] = useState();
    const [isRefreshingAfterSave, setIsRefreshingAfterSave] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [confirmDeleteAction, setConfirmDeleteAction] = useState();
    const alert = useAlert();
    const appRoutesRef = useRef();
    appRoutesRef.current = appRoutes;

    const [statusDetail, loadingStatus, loadingStatusError, refreshStatus] = useFetch(entity && detail && detail.status ? endpoints.getStatusForEntityAndStatus + entity.name + '/' + detail.status : null);

    const secondEntity = entity.seconadaryEntity && entity.seconadaryEntity.value && detail && detail[entity.seconadaryEntity.value] ? detail[entity.seconadaryEntity.value] : null;

    const actionFetch = newItem || (detail && !detail.id) ? endpoints.getActionsForEntity + entity.name : detail && entity ? endpoints.getActionsForEntityItem + entity.name + '/' + detail.id : null;
    const [allowedActions1, loadingActions1, loadingError1, refreshActions1] = useFetch(actionFetch);
    const [allowedActions2, loadingActions2, loadingError2, refreshActions2] = useFetch(newItem || (detail && !detail.id) ? endpoints.getActionsForEntity + entity.name : detail && secondEntity ? endpoints.getActionsForEntityItem + entity.seconadaryEntity.name + '/' + detail[entity.seconadaryEntity.value].id : null);
    const loadingActions = loadingActions1 && loadingActions2;
    const loadingError = loadingError1 && loadingError2;
    const fetch = useFetchSimple();

    useEffect(() => {
        if (newItem && !detail) {
            setEdit(true);
            setDetail(newItem);
            setDetailId(newItem.id + newItem.status);
            refreshActions1(true);
            refreshActions2(true);
            refreshStatus();
        }
    }, [detail, edit, newItem, refreshActions1, refreshActions2, refreshStatus])
    useEffect(() => {
        if (fetchDetail) {
            if (entity.prepareForEdit) {
                setDetail(entity.prepareForEdit(fetchDetail));
            }
            else {
                setDetail(fetchDetail);
            }
        }
    }, [fetchDetail, entity])
    useEffect(() => {
        setEdit(edit);
    }, [edit])
    useEffect(() => {
        if (itemId && !item && !fetchDetail && !loadingRequest && !errorRequest) {
            refreshDetail();

        }

    }, [entity, item, itemId, refreshDetail, fetchDetail, loadingRequest, errorRequest]);
    useEffect(() => {
        const di = getDetailId(detail)
        if (detail && detailId !== di) {
            setDetailId(di);

            refreshActions1(true);
            refreshActions2(true);
            refreshStatus();
        }

    }, [detail, detailId, refreshActions1, refreshActions2, refreshStatus]);
    const onCloseModal = () => {
        if (!newItem) {
            setDetail();
            setEdit(false);
            if (editorClosed) {
                editorClosed()
            }
            else {
                goBack();
            }
        }

        else {
            setEdit(false);
            setNewNotSaved(false);
            setDetail();
            goBack()
            if (editorClosed) {
                editorClosed()
            } else {
                goBack();
            }

        }


    }


    const goBack = () => {
        history.push(route);
    }
    const postSubmit = useCallback((url, verb, values) => {
        const val = entity.beforeSave ? entity.beforeSave(values) : values;

        let requestBody = JSON.stringify(val);

        
        let encodingRequests=["sendemails","newbid","aircraft/add","aircraft/update","newcharterrequest",
                                      "clonecharterrequest","updatecharterrequest","updatechangecharter","updatemanifest",
                                      "newchangecharter","updatechartershare","updatechartersharepurchase","updateterms"];   
        
        if (url && encodingRequests.some(req => url.toLowerCase().includes(req))) {
                    requestBody = JSON.stringify({ encodedData: base64Encode(requestBody) });
            }

        const options = { method: 'POST', body: requestBody };

        setLoading(true);
        return fetch(url, options).then((result) => {
            var ret = result.body;
            if (ret.success) {
                if (!isNewItem && itemId && refreshDetail) {
                    setIsRefreshingAfterSave(true);
                    const refreshPromise = fetchDetailData instanceof Function ? fetchDetailData(true) : refreshDetail();
                    Promise.resolve(refreshPromise).finally(() => {
                        setIsRefreshingAfterSave(false);
                    });
                }
                const m = ret.messages;
                alert({
                    title: verb, body: <div>
                        {entity.saveMessage ? entity.saveMessage({ ...detail, ...item, ...values }) : <h5>{verb} {entity.getTitle({ ...detail, ...item, ...ret.result })}</h5>}
                        {m && m.length ? m.map(x => <p>{x}</p>) : null}
                    </div>
                    , onDismiss: () => {
                        setEdit(false);
                        setLoading(false);
                        //if (editorClosed) {
                        //    editorClosed()
                        //} else {
                        //    goBack();
                        //}
                    }
                });
            }
            else {
                alert({

                    title: "Error", body: <div>
                        <h5>{"Error - " + entity.title + ' ' + entity.getTitle(values)}</h5>
                        {ret.messages && ret.messages.length ? ret.messages.map(x => <p>{x}</p>) : null}
                    </div>
                    , onDismiss: () => {

                        setLoading(false);

                    }
                });

            }


        }, (error) => {
            const errors = error?.body?.errors;
            const messages = errors ? Object.keys(errors).map((x, i) => {
                return <p key={i}>{errors[x].map(y => y)}</p>
            }) : null
            alert({
                title: 'Error saving' + entity.title, body: <div>
                    <h3>Unexpected Result</h3>
                    {messages ? messages : JSON.stringify(error)}
                </div>
            });

            setLoading(false);
        }).catch((e) => {
            alert({ title: 'Error saving' + entity.title, body: "Exception Result: " + e ? JSON.stringify(e) : 'No Error!' });
            setLoading(false);
        })
    }, [entity, alert, detail, fetch, item, isNewItem, itemId, refreshDetail, fetchDetailData]);

    const doSubmit = useCallback((values, actions) => {
        const url = isNewItem ? entity.addSingle : entity.saveSingle;
        onSave ? onSave(values) : postSubmit(url, "Saved ", values);
    }, [isNewItem, entity, onSave, postSubmit]);

    const performDelete = useCallback(() => {
        const url = isNewItem ? entity.removeSingle : entity.removeSingle + itemId;
        postSubmit(url, "Deleted ");
    }, [entity, isNewItem, itemId, postSubmit]);

    const cancelEdit = () => {
        setEdit(false);
    }
    const closeExtraData = (v) => {
        if (v) {
            setExtraDataResult(v);
        } else {
            setExtraData();
        }


    }
    useEffect(() => {
        if (extraDataResult && extraData && extraData.action) {

            const updateItem = {
                id: itemId,
                allowedActionId: extraData.action.id,
                entity: entity.name,
                currentStatus: detail.status,
                newStatus: extraData.action.nextState,
                ...extraDataResult,
            }
            postSubmit(endpoints.setItemStatus, "Updated ", updateItem);

            setExtraData();
        }
    }, [extraDataResult, postSubmit, entity, extraData, itemId, detail]);
    useEffect(() => {
        if (detail && allowedActions1 && auth) {
            const test = 'canEdit' + auth.role;
            let canEdit = false;
            if (statusDetail && statusDetail[test] && !editState) {
                canEdit = true;
            }
            const allowed1 = editState ? [] : allowedActions1 ? allowedActions1.filter(x => x.allowedRole === auth.role && x.entityState === detail.status) : null;
            const allowed2 = editState || !secondEntity ? [] : allowedActions2 ? allowedActions2.filter(x => x.allowedRole === auth.role && x.entityState === secondEntity.status) : null;
            const isAircraftDelete = entity?.name === 'AircraftInventory';
            const isDeleteLikeAction = (x) => {
                const actionName = (x?.actionName || '').toLowerCase();
                const nextState = (x?.nextState || '').toLowerCase();
                return actionName.includes('delete') || nextState.includes('delete') || nextState.includes('remove');
            };

            const newActions = () => {
                const handleDeleteClick = () => {
                    if (isAircraftDelete) {
                        setShowDeleteConfirm(true);
                        return;
                    }
                    performDelete();
                };

                return loading || loadingRequest || loadingActions || loadingStatus ? <LoadingAnimation height='40px' /> : <React.Fragment >
                    {(detail && !editState && entity.removeSingle) && <Button onClick={handleDeleteClick}>Delete</Button>}
                    {canEdit && !editState && <Button onClick={() => setEdit(!editState)}>Edit</Button>}
                    {(!hideSave && editState && !isNewItem) ?
                        <Button onClick={handleSubmit}>Save</Button> : null}
                    {(!hideSave && isNewItem) ?
                        <Button onClick={handleSubmit}>Save New</Button> : null}
                    {(editState && !isNewItem) ? <Button onClick={cancelEdit}>Cancel Edit</Button> : null}
                    {
                        allowed1 && allowed1.map((x, i) => {
                            const updateItem = {
                                id: itemId,
                                allowedActionId: x.id,
                                entity: entity.name,
                                currentStatus: detail.status,
                                newStatus: x.nextState,
                                reason: 'No Reason.'
                            }

                            const handleClick = () => {
                                const controls = x.dataEntry.filter(x =>
                                    x.dataEntryFilter === 'All'
                                    || (x.dataEntryFilter === 'QGov' && detail.qGov)
                                    || (x.dataEntryFilter === 'NotQGov' && !detail.qGov))

                                if (isAircraftDelete && isDeleteLikeAction(x)) {
                                    setConfirmDeleteAction(() => () => {
                                        if (controls.length === 0) {
                                            postSubmit(endpoints.setItemStatus, "Updated ", { ...updateItem, ...item });
                                        }
                                        else {
                                            setExtraData({ controls, action: x });
                                        }
                                    });
                                    setShowDeleteConfirm(true);
                                    return;
                                }

                                if (x.actionType === "Route") {

                                    const routeDefinition = { action: x, ...appRoutesRef.current[x.appRoute], controls };
                                    setAppRoute(routeDefinition);
                                }
                                else {
                                    if (controls.length === 0) {

                                        postSubmit(endpoints.setItemStatus, "Updated ", { ...updateItem, ...item });

                                    }
                                    else {
                                        setExtraData({ controls, action: x });

                                    }
                                }
                            }

                            return <Button key={i} onClick={() => handleClick()}>{x.actionName}</Button>


                        })

                    }
                    {allowed2 && allowed2.map((x, i) => {
                        const updateItem = {
                            id: secondEntity.id,
                            allowedActionId: x.id,
                            entity: entity.seconadaryEntity.name,
                            currentStatus: secondEntity.status,
                            newStatus: x.nextState,
                            reason: 'No Reason.'
                        }

                        const handleClick = () => {
                            const controls = x.dataEntry.filter(x =>
                                x.dataEntryFilter === 'All'
                                || (x.dataEntryFilter === 'QGov' && detail.qGov)
                                || (x.dataEntryFilter === 'NotQGov' && !detail.qGov))
                            if (x.actionType === "Route") {

                                const routeDefinition = { action: x, ...appRoutesRef.current[x.appRoute], controls };
                                setAppRoute(routeDefinition);
                            }
                            else {


                                if (controls.length === 0) {
                                    postSubmit(endpoints.setItemStatus, "Updated ", { ...updateItem, ...item });
                                }
                                else {
                                    setExtraData({ controls, action: x });

                                }
                            }
                        }

                        return <Button key={i} onClick={() => handleClick()}>{x.actionName}</Button>


                    })
                    }
                </React.Fragment >
            }
            setActions(newActions);
        }


    }, [handleSubmit, detail, entity, allowedActions1, statusDetail, editState,
        auth, isNewItem, edit, loading, loadingRequest, loadingStatus,
        route, allowedActions2, secondEntity, item, itemId, hideSave, loadingActions, postSubmit, performDelete]);
    const closeAppRoute = () => {
        setAppRoute();
        if (!isNewItem && itemId) {
            const refreshFn = fetchDetailData instanceof Function ? () => fetchDetailData(true) : refreshDetail;
            refreshFn && refreshFn();
        }
    }


    return <React.Fragment>

        <ConfirmationModal
            showModal={showDeleteConfirm}
            onClose={() => {
                setShowDeleteConfirm(false);
                if (confirmDeleteAction) {
                    confirmDeleteAction();
                }
                else {
                    performDelete();
                }
                setConfirmDeleteAction();
            }}
            onCancelHandle={() => {
                setShowDeleteConfirm(false);
                setConfirmDeleteAction();
            }}
            messagePrimary="Are you sure you want to delete this aircraft?"
            messageSecondary="This action cannot be undone."
            confirmLabel="Delete"
            cancelLabel="Cancel"
        />

        {extraData ? <ExtraDataModal extraData={extraData.controls} onClose={closeExtraData} parentEntityItem={detail} /> : null}
        {appRoute ? <RouteModal appRoutes={appRoutes} appRoute={appRoute} parentEntity={entity} parentEntityItem={detail} route={route} onClose={closeAppRoute} /> : null}
        <Modal open={itemId || isNewItem || newNotSaved} onClose={onCloseModal} title={<EditorTitle entity={entity} detail={detail} />} actions={!isSubmitting ? actions : null} heightOffset={entity.heightOffset} >
            {isRefreshingAfterSave ? <div style={{ marginBottom: '8px', fontSize: '0.9rem', fontWeight: 'bold', color: '#1f6fb2' }}>Saved, refreshing...</div> : null}
            {loadingRequest ? <LoadingAnimation /> : null}
            {errorRequest ? <h5>Error Loading {entity.title}</h5> : null}
            {loadingStatusError ? <h5>Error Loading Status</h5> : null}
            {loadingError ? <h5>Error Loading Actions</h5> : null}
            {(entity.getSingle || entity.getAll || entity.getByStatus) && (entity.name === 'CharterRequest' || entity.name === 'Bid') && !fetchDetail && !loadingRequest ? <h3>Sorry, this item is not available</h3> : null}
            {(itemId || isNewItem) && detail ? <RefreshProvider refresh={fetchDetailData instanceof Function ? () => fetchDetailData(true) : refreshDetail}>
                <FormContainer initialValues={detail} validationSchema={entity.validationSchema} edit={editState} newRequest={false} setHandleSubmit={setHandleSubmit} onSubmit={doSubmit} setSubmitting={setSubmit}>
                    {entity.editor && (!children || newItem || item) ? <entity.editor data={data} editState={editState} entity={entity} isNewItem={newItem} item={newItem ? newItem : item} route={route} /> : children}
                </FormContainer >
            </RefreshProvider> : null}
        </Modal>
    </React.Fragment>
}

export default Editor;